import Vue from 'vue';

export let SearchSponsors = {
    data () {
        return {
            fieldList: [],
            module: window.immiObj.module,
        }
    },
    created () {
        this.$root.$on('search-sponsor', (form, formFields) => {
            const forms = Object.keys(form);
            const fieldList = Object.keys(formFields);
            this.fieldList = [];
            let data = {};
            if (formFields && fieldList.length) {
                fieldList.forEach(field => {
                    if (typeof this.findNclear === 'function') this.findNclear(field);
                    this.fieldList.push({
                        name: field,
                        value: formFields[field] || null
                    });
                    data[field] = formFields[field] || null;
                });
            }
            
            if (forms && forms.length) {
                forms.forEach(field => {
                    if (typeof this.findNclear === 'function') this.findNclear(field);
                    this.fieldList.push({
                        name: field,
                        value: form[field] || null
                    });
                    data[field] = form[field] || null;
                })
            }
            
            Vue.nextTick(()=>{
                // document.getElementById('searchForm').submit();
                this.$http.post(this.module == 'h1bVisa' ? '/h1b-visa-sponsors/search-results/' : '/greencard-sponsors/search-results/', data).then(res=>{
                    const responseBody = res.body;
                    if (responseBody && responseBody.message) {
                        window.location.href = this.module == 'h1bVisa' ? '/h1b-visa-sponsors/search-results/' : '/greencard-sponsors/search-results/';
                    }
                })
            })
        });
    }
}